import dayjs from 'dayjs';
import * as yup from 'yup';
import { StringSchema } from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Valida una data mantenendo lo schema stringa nel formato fornito (default YYYY-MM-DD).
     */
    stringDate(
      format?: string | undefined,
      /** Valore custom in caso di cast non pervenuto */
      defaultValue?: string | undefined,
    ): StringSchema;

    /**
     * Controlla che la data (in formato stringa) in esame sia successiva alla data fornita.
     */
    isAfter(fromDate: string, errorMessage: string): StringSchema;
  }
}

/**
 * Valida una data mantenendo lo schema stringa nel formato fornito (default YYYY-MM-DD).
 */
yup.addMethod(
  yup.string,
  'stringDate',
  function (
    format: string | undefined = 'YYYY-MM-DD',
    defaultValue: string | undefined,
  ) {
    return this.test({
      name: 'stringDate',
      message: '${label} deve essere una data valida',
      test: value => {
        if (!value) {
          return true;
        }

        return dayjs(value, [
          'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
          'YYYY-MM-DD[T]HH:mm:ss',
          'YYYY-MM-DD[T]HH:mm',
          'YYYY-MM-DD',
          'DD/MM/YYYY',
          'MMM DD YYYY hh:mmA',
        ]).isValid();
      },
    })
      .transform(function (value: dayjs.Dayjs) {
        const dateValue = dayjs(value, [
          'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
          'YYYY-MM-DD[T]HH:mm:ss',
          'YYYY-MM-DD[T]HH:mm',
          'YYYY-MM-DD',
          'DD/MM/YYYY',
          'MMM DD YYYY hh:mmA',
        ]);
        return dateValue.isValid() ? dateValue.format(format) : defaultValue;
      })
      .meta({ [IsStringDateMetaKey]: true });
  },
);

export const IsStringDateMetaKey = 'isStringDate';

/**
 * Controlla che la data (in formato stringa) in esame sia successiva alla data fornita.
 */
yup.addMethod(
  yup.string,
  'isAfter',
  function (this, fromDate: string, errorMessage: string) {
    return this.when(fromDate, ([fromDate], schema) => {
      //  'La ${label} deve essere successiva alla da\ta di inizio'
      return schema.test(
        'date-after-test',
        errorMessage,
        (dateToCheck: string | undefined) => {
          if (!dateToCheck || !fromDate) return true;
          return dayjs(dateToCheck).isAfter(dayjs(fromDate));
        },
      );
    });
  },
);
